import React, { useContext } from 'react';
import { View } from '@shared/components/View';
import { grid } from '@shared/styles';
import { useLayoutConfig } from '../contexts/layoutConfig';
import { CardRenderContext } from '../contexts/render';
import { FileUpload } from '../types';
import { MBBlockLabel } from '../utils/label';
import { InputBlockMedia } from './inputFile/InputBlockMedia';

interface Props {
  value: FileUpload[];
  label?: string;
}

export function MBFieldFileBlock({ value, label }: Props) {
  const {
    staticBlock: { displayLabel, paddingLeft },
  } = useLayoutConfig();
  const renderContext = useContext(CardRenderContext);
  const isCompactFileView = renderContext !== 'detail' && renderContext !== 'form';

  return (
    <View paddingVertical={0.5}>
      {displayLabel && !!label && (
        <View row paddingLeft={paddingLeft} paddingRight={4} paddingBottom={0.5}>
          <MBBlockLabel label={label} />
        </View>
      )}
      <InputBlockMedia
        files={value}
        compactFileView={isCompactFileView}
        maxHeight={grid(8)}
        maxWidth={grid(8)}
        verticalPadding={0}
        horizontalPadding={2}
        numImagesToShow={3}
        editable={false}
      />
    </View>
  );
}
